import React, {useState,useEffect} from "react";
import { useTranslate } from 'react-redux-multilingual';
import {Loading,StockAdjustmentDetailTable} from "@gull";
import axios from 'axios'
import swal from "sweetalert2"
import { devises_list } from "app/devises";

const useLoad = (props) => {
    const t = useTranslate();
    const [articleListInfo,setArticleListInfo]=useState({
        zone:'',
        bins:'',
        section:'',
        list_detail:[],
    })
    const [customFields,setCustomFields]=useState([])
    const [reload,setReload]=useState(Date.now())
    const [liaisons,setLiaisons]=useState([])
    const [customInterface, setCustomInterface] = useState({})
    const [loadCustomFields,setLoadCustomFields] = useState(true)
    const [loadLiaison,setLoadLiaison] = useState(true)

    const [optionsDataTable,setOptionsDataTable]=useState({
        devise:[],
        marque:[],
        fournisseur:[],
        firstlevelcat:[],
        secondlevelcat:[],
        thirdlevelcat:[],
        fourthlevelcat:[],
        fifthlevelcat:[]

    })
    const [ourOptionsDataTable,setOurOptionsDataTable]=useState({
        devise:{},
        marque:{},
        fournisseur:{},
        firstlevelcat:{},
        secondlevelcat:{},
        thirdlevelcat:{},
        fourthlevelcat:{},
        fifthlevelcat:{}

    })

    useEffect(function () {
        if (props.module != 'erp') {
            (async function() {
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/custom_fields/all/article"
                ).then((response) => {
                    setCustomFields(response.data.datas)
                }).catch((error) => {
                    if(error=='end_session') return;
                    let messageError
                    if(error.response==undefined){
                        messageError='unknowError'
                    }
                    else if(error.response.status==403){
                        messageError='forbiddenGeneral'
                    }
                    else {
                        messageError='unknowError'
                    }
                    swal.fire(t(messageError), "", "error");
                })
                setLoadCustomFields(false)
            })()
        }
        else {
            if (props.customFields) {
                setCustomFields(props.customFields)
            }
            setLoadCustomFields(false)
        }
    }, [reload])

    useEffect(function () {
        if (props.module != 'erp') {
            (async function() {
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/liaison"
                ).then((response) => {
                    setLiaisons(response.data.datas)

                    let arr = ['firstlevelcat','secondlevelcat','thirdlevelcat','fourthlevelcat','fifthlevelcat','fournisseur','marque']
                    //on crée une zone de stockage temporaire des données avant de tout set
                    let optionsDataTableTemp = optionsDataTable
                    let ourOptionsDataTableTemp = ourOptionsDataTable
                    
                    //formatage des options du select dans le cell edit du datatable pour les devises
                    let arrDevise=[]
                    let objDeviseOur={}
                    devises_list.map(value=>{
                        arrDevise.push({'value':value.name+" - "+value.code,'label':value.name+" - "+value.code})
                        objDeviseOur[value.name+" - "+value.code]=value.code
                    })

                    optionsDataTableTemp={...optionsDataTableTemp,devise:arrDevise}
                    ourOptionsDataTableTemp={...ourOptionsDataTableTemp,devise:objDeviseOur}

                    //formatage des options du select dans le cell edit du datatable pour le reste des colones
                    arr.forEach(item=>{
                        let optionsArr = [{'value':t('emptyValue'),'label':t('emptyValue')}]
                        let ourOptionObj = {}

                        ourOptionObj[t('emptyValue')]=''
                        response.data.datas[item].map(value=>{
                            optionsArr.push({'value':value.name,'label':value.name})
                            ourOptionObj[value.name]=value.id
                        })

                        optionsDataTableTemp={...optionsDataTableTemp,[item]:optionsArr}
                        ourOptionsDataTableTemp={...ourOptionsDataTableTemp,[item]:ourOptionObj}
                    })

                    setOptionsDataTable(optionsDataTableTemp)
                    setOurOptionsDataTable(ourOptionsDataTableTemp)

                    setCustomInterface(response.data.custom_interface)
                }).catch((error) => {
                    if(error=='end_session') return;
                    let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                    swal.fire(t(errorName), "", "error");
                })
                setLoadLiaison(false)
            })()
        }
        else {
            if (props.liaisons) {
                setLiaisons(props.liaisons)
            }
            if (props.optionsDataTable) {
                setOptionsDataTable(props.optionsDataTable)
            }
            if (props.ourOptionsDataTable) {
                setOurOptionsDataTable(props.ourOptionsDataTable)
            }
            if (props.customInterface) {
                setCustomInterface(props.customInterface)
            }
            setLoadLiaison(false)
        }
    }, [reload])
    
    return [loadLiaison,loadCustomFields,articleListInfo,setArticleListInfo,customFields,optionsDataTable,ourOptionsDataTable,liaisons,customInterface,setCustomInterface,setReload]
} 

const StockAdjustmentList = (props) => {
    const t = useTranslate();
    const [loadLiaison,loadCustomFields,articleListInfo,setArticleListInfo,customFields,optionsDataTable,ourOptionsDataTable,liaisons,customInterface,setCustomInterface,setReload]=useLoad(props)

    if(loadLiaison || loadCustomFields ){
        return (<Loading></Loading>);
    }

    return (<>
        <StockAdjustmentDetailTable 
            articleListInfo={articleListInfo}
            setArticleListInfo={setArticleListInfo}
            customFields={customFields}
            optionsDataTable={optionsDataTable}
            ourOptionsDataTable={ourOptionsDataTable}

            liaisons={liaisons}
            customInterface={customInterface}
            setCustomInterface={setCustomInterface}
            setReload={setReload}
            module={props.module}
            allSections={props.allSections}
            section={props.section}
        />
    </>
    );
}

export default StockAdjustmentList;


